import { MenuOption } from '@lexical/react/LexicalTypeaheadMenuPlugin';

import { FormulaReferenceOption } from '../../../../utils/formulas/types';

export type MentionTypeaheadOption = MenuOption & {
  mention: FormulaReferenceOption;
};

export const createMentionTypeaheadOption = (mention: FormulaReferenceOption): MentionTypeaheadOption =>
  Object.assign(new MenuOption(String(mention.id)), { mention });
